import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowRightIcon } from "lucide-react";

interface ProcessingStepsCardProps {
  steps: string[];
}

export default function ProcessingStepsCard({
  steps,
}: ProcessingStepsCardProps) {
  return (
    <Card className="shadow-md h-full">
      <CardHeader className="bg-slate-100 pb-2">
        <CardTitle className="text-lg font-medium">
          Suggested Way of Processing
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4">
        <div className="flex flex-wrap items-center">
          {steps.map((step, index) => (
            <div key={index} className="flex items-center">
              <span className="text-sm">{step}</span>
              {index < steps.length - 1 && (
                <ArrowRightIcon className="mx-2 text-slate-400" size={16} />
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
